/* eslint-disable eqeqeq */
class ErrorHandler {

  Parse(error) {
    if (!error) throw new SyntaxError('Missing required argument: error; nothing to parse!');
    const output = {
      notification: null,
      debugNotification: null,
      console: null,
    };

    if (error.code == 4001 || error.message === 'User rejected the transaction') { // MM || WC
      output.console = 'User rejected transaction';
      output.notification = 'Operation canceled by user!';
    } else if (error.code == 4200) { // TW
      output.console = 'Trustwallet error; code: ' + error.code;
      output.notification = 'Unknown TrustWallet error';
      output.debugNotification = ('Generic Trustwallet error occurred; details for devs:\n' + error, error.message);
    } else if (error.message === 'User canceled') { // WC
      output.console = 'User rejected transaction';
      output.notification = 'Canceled by user';
    } else if (error.message === 'Unexpected end of JSON input') { // WC
      output.console = 'We are either offline or our RPC is glitching out';
      output.notification = 'Lost connection with WalletConnect';
      output.debugNotification = 'You appear to be offline; check your internet connection';
    } else if (error.message === 'User closed modal') { // WC
      output.console = 'User closed WalletConnect modal';
      output.notification = 'Connection via WC rejected';
    } else if (error.message === 'Internal JSON-RPC error.') { // WCv1 and mobile MM wallet
      alert(Object.keys(error.message));
      alert(Object.keys(error));
      output.console = 'Generic JSON-RPC error returned, likely a mobile app';
      output.notification = 'Unspecified error ocurred in your mobile wallet app';
      output.debugNotification = 'Error is: ' + JSON.stringfiy(error.message);

    } else if (error.message.includes('Transaction has been reverted')) {
      output.console = 'Transaction reverteded by the blockchain';
      output.notification = 'Transaction failed'
    } else if (error.message.includes('underpriced')) {
      output.console = 'RPC reported TX as being underpriced';
      output.notification = 'Transaction underpriced; try increasing gas';
    } else {
      output.console = ('Error, whole, repeated: ' + error + '\nError, message: ' + error.message + 
        '\nError, code: ' + error.code + 'Error, keys: ' + Object.keys(error));
      if (error.receipt) console.log(error.receipt);
      output.notification = 'Unknown Wallet error';
      output.debugNotification = ('Error details: ' + error.message + '\n' + error.code);
    }

    return output;
  }
} /* eslint-enable eqeqeq */



export default function HandleWalletError(error) {
  const formatedError = GetFormattedError(error);
  if (formatedError.debugNotification)
    alert(formatedError.debugNotification);
  else
    alert(formatedError.notification);
  console.log(formatedError.console);
}

export function GetFormattedError(error) {
  let parsedError = handler.Parse(error);
  console.log(parsedError);
  if (!parsedError) {
    console.log('Can\'t parse error');
  }
  return parsedError;
}

const handler = new ErrorHandler();


/*
Abbreviations:
  MM - MetaMask
  TW - TrustWallet
  WC - WalletConnect
*/
